import React from "react";

export type ErrorTextProps = React.PropsWithChildren & {
    className?: string;
};

const ErrorText = ({ children, className }: ErrorTextProps): JSX.Element => {
    return (
        <div className={className}>
            <div className="text-destructive text-sm">{children}</div>
        </div>
    );
};
ErrorText.displayName = "ErrorText";

export { ErrorText };
